import { useMemo, useState } from 'react';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import type { MediaPhotoWithCropAndAlignmentInfo } from '@apps/admin/routes/WebsiteDesignerV2/routes/Layout/components/HeaderPhotoCustomization/HeaderPhotoCustomization.types';

export const usePhotoUrlBridge = (imageUrl: string | undefined | null, onImageUrlChange: (url: string) => void) => {
  // Track the real MediaPhoto ID so the picker grid can highlight the current selection on reopen.
  const [mediaPhotoId, setMediaPhotoId] = useState<string | null>(null);

  const selectedPhotos: readonly MediaPhotoWithCropAndAlignmentInfo[] = useMemo(() => {
    if (!imageUrl) return [];
    return [{ id: mediaPhotoId || imageUrl, url: imageUrl, width: 0, height: 0 }];
  }, [imageUrl, mediaPhotoId]);

  const handlePhotosChange = useEventCallback((photos: MediaPhotoWithCropAndAlignmentInfo[]) => {
    if (photos.length > 0) {
      setMediaPhotoId(photos[0].id);
      onImageUrlChange(photos[0].url);
    } else {
      setMediaPhotoId(null);
      onImageUrlChange('');
    }
  });

  return { selectedPhotos, handlePhotosChange };
};
